import React, { useEffect, useState } from "react";
import {
	BrowserRouter as Router,
	Switch,
	Route,
	Redirect,
} from "react-router-dom";
import Uploaddesign from "../pages/Uploaddesign/Uploaddesign";
import Describecampaign from "../pages/Describecampaign/Describecampaign";
import Choosegarments from "../pages/Choosegarment/Choosegarment";
import Setprice from "../pages/Setprice/Setprice";
import Preview from "../pages/Preview/Preview";
import Donepreview from "../pages/Preview/Donepreview.jsx";
import Smallscreens from "../components/Smallscreens/Smallscreens";
import Adminuploadgarments from "../pages/Choosegarment/adminuploadgarments";
import Homepage from "../pages/Dashboard/Home";
import Campaign from "../pages/Dashboard/Campaign";
import CompaignDetail from "../pages/Dashboard/Campaigndetail";
import CompaignDraft from "../pages/Dashboard/Campaigndraft";
import Setting from "../pages/Dashboard/Setting";
import Payment from "../pages/Dashboard/Payment";
import Order from "../pages/Dashboard/Order";
import Stripe from "../components/Stripe/index";
import Authentication from "../pages/Dashboard/Auth";
import { useSelector } from "react-redux";
import Referral from "../pages/Dashboard/Referral";
import OrderProduct from "../pages/Dashboard/OrderProduct";
import { UseWindowSize } from "../hooks/Usewindow";
import AdminBoard from "../pages/Dashboard/Admin";
import UserDetail from "../pages/Dashboard/UsersDetails";
import ConfirmPay from "../pages/Dashboard/ConfirmPay";
import CheckUserName from "../pages/CheckUserName/CheckUserName";
import Samples from "../pages/Dashboard/Samples";

const Routers = () => {
	const logindata = useSelector((state) => state.login);
	const width = UseWindowSize();
	return (
		<Router>
			{width.width < 1150 ? (
				<Switch>
					<Route
						exact
						path="/"
						component={logindata.loginStatus ? Smallscreens : Authentication}
					/>
					<Route path="*">
						<Redirect to="/" />
					</Route>
				</Switch>
			) : logindata.loginStatus && logindata.checkName ? (
				<Switch>
					<Route path="/" component={CheckUserName} />
				</Switch>
			) : logindata.loginStatus && !logindata.checkName ? (
				<Switch>
					<Route exact path="/" component={Choosegarments} />
					<Route path="/home" component={Homepage} />
					<Route path="/campaign" component={Campaign} />
					<Route path="/compaigndetail/:id" component={CompaignDetail} />
					<Route path="/compaigndraft" component={CompaignDraft} />
					<Route path="/setting" component={Setting} />
					<Route path="/referral" component={Referral} />
					<Route path="/payment" component={Payment} />
					<Route path="/order" component={Order} />
					<Route path="/orderproduct" component={OrderProduct} />
					<Route path="/pay" component={Stripe} />
					<Route path="/design" component={Uploaddesign} />
					<Route path="/adminupload" component={Adminuploadgarments} />
					<Route path="/describecampaign" component={Describecampaign} />
					<Route path="/setprice" component={Setprice} />
					<Route path="/preview" component={Preview} />
					<Route path="/donepreview/:id" component={Donepreview} />
					<Route path="/adminboard" component={AdminBoard} />
					<Route path="/userdetails/:id" component={UserDetail} />
					<Route path="/confirmPay" component={ConfirmPay} />
					<Route path="/samples" component={Samples} />
					<Route path="*">
						<Redirect to="/home" />
					</Route>
				</Switch>
			) : width.width > 1150 ? (
				<Switch>
					<Route exact path="/" component={Choosegarments} />
					<Route path="/design" component={Uploaddesign} />
					<Route path="/adminupload" component={Adminuploadgarments} />
					<Route path="/describecampaign" component={Describecampaign} />
					<Route path="/setprice" component={Setprice} />
					<Route path="/preview" component={Preview} />
					<Route path="/donepreview/:id" component={Donepreview} />
					<Route path="/auth" component={Authentication} />
					<Route path="/confirmPay" component={ConfirmPay} />
					<Route path="*">
						<Redirect to="/auth" />
					</Route>
				</Switch>
			) : null}
		</Router>
	);
};
export default Routers;
